export default __webpack_public_path__ + "static/media/logout.d78f466c.svg";